window.addEventListener("resize", () => {
    if (window.innerWidth != width) {
        width = window.innerWidth;
        // height = window.innerWidth;
        if (typeof heroes != "undefined" && heroes != null) {
            makeFullHeight(heroes);
        }
    
        if (typeof articleScrollButtonWrapper != "undefined" && articleScrollButtonWrapper != null) {
            makeFullHeight(articleScrollButtonWrapper);
        }
    }
    
});
